import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "push_notifications",
    object: "push_notification",
    header: [
      // { text: "ID", value: "id" },
      { text: "Date", value: "created_at" },
      { text: "Title", value: "title" },
      { text: "Body", value: "body" },
      { text: "Type", value: "type" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
